import React from "react";
import ReactDOM from "react-dom";

import App from "./components/App";

// global flag to determine if a component was mounted
let __MOUNTED__ = false;

const wrappedComponent = (component) => (
    <App>{component}</App>
);

export function register(view, component) {
    // find element by it's ID
    const element = document.getElementById(`react::${view}`);

    if (element) {
        // create new props object with server rendered __DATA__
        const props = Object.assign({},
            window.__DATA__
        );

        // create a react component node with properties
        const node = wrappedComponent(
            React.createElement(component, props)
        );

        // mount our page component there
        ReactDOM.render(node, element);

        // indicate that a component was mounted
        __MOUNTED__ = true;
    }
}

export const handlePageNotFound = () => {
    if (!__MOUNTED__) {
        throw new Error('No react page for your given laravel view defined. Did you \'register\' it in the app entry point?');
    }
};


// WEBPACK FOOTER //
// ./resources/assets/js/register.js